import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Container, Typography, Box, CircularProgress, Button, Paper } from '@mui/material';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import { apiService } from '../utils/api';
import { useAuth } from '../contexts/AuthContext';

const VerifyEmail = () => {
  const { token } = useParams();
  const navigate = useNavigate();
  const { login } = useAuth();
  const [loading, setLoading] = useState(true);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState('');
  const [verificationData, setVerificationData] = useState(null);

  useEffect(() => {
    const verifyEmail = async () => {
      if (!token) {
        setError('認証トークンがありません');
        setLoading(false);
        return;
      }

      try {
        const response = await apiService.post('/api/auth/verify-email', { token });
        
        if (response.data && response.data.success) {
          setSuccess(true);
          setVerificationData(response.data);
          
          // 認証と同時にログインする場合
          if (response.data.access_token && response.data.user) {
            login(response.data.user, response.data.access_token, response.data.refresh_token);
          }
        }
      } catch (error) {
        
        setError(error.response?.data?.message || 'メール認証に失敗しました');
      } finally {
        setLoading(false);
      }
    };

    verifyEmail();
  }, [token, login]);

  const handleGoToLogin = () => {
    navigate('/login');
  };

  const handleGoToHome = () => {
    navigate('/');
  };

  if (loading) {
    return (
      <Container maxWidth="sm">
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            minHeight: '80vh',
          }}
        >
          <CircularProgress />
          <Typography variant="h6" sx={{ mt: 2 }}>
            メールアドレスを認証中...
          </Typography>
        </Box>
      </Container>
    );
  }

  return (
    <Container maxWidth="sm">
      <Paper
        elevation={3}
        sx={{
          p: 4,
          mt: 6,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
        }}
      >
        {success ? (
          <>
            <CheckCircleOutlineIcon color="success" sx={{ fontSize: 60 }} />
            <Typography variant="h5" sx={{ mt: 2 }}>
              メールアドレスが認証されました！
            </Typography>
            <Typography variant="body1" sx={{ mt: 2, textAlign: 'center' }}>
              {verificationData?.message || 'アカウントのメールアドレスが正常に認証されました。'}
            </Typography>
            <Box sx={{ mt: 3, display: 'flex', gap: 2 }}>
              <Button variant="contained" color="primary" onClick={handleGoToHome}>
                ホームに移動
              </Button>
            </Box>
          </>
        ) : (
          <>
            <ErrorOutlineIcon color="error" sx={{ fontSize: 60 }} />
            <Typography variant="h5" sx={{ mt: 2 }}>
              メールアドレスの認証に失敗しました
            </Typography>
            <Typography variant="body1" sx={{ mt: 2, textAlign: 'center' }}>
              {error || '認証リンクが無効または期限切れです。もう一度お試しください。'}
            </Typography>
            <Box sx={{ mt: 3 }}>
              <Button variant="contained" color="primary" onClick={handleGoToLogin}>
                ログインページへ
              </Button>
            </Box>
          </>
        )}
      </Paper>
    </Container>
  );
};

export default VerifyEmail; 